// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"affad5c7","77":"790d325b","141":"c7c2c12d","335":"2fd59005","688":"df5d374b","953":"d9c0d68b"}[chunkId] + ".chunk.css";
};